<!--
================================================
Un composant affichant la liste des tags du workspace

Composant créé depuis une copie de ProjectListComp)

Url d'accès :
http://localhost:8080/fr/samsonite/samsonite-workspace/tags

LIMITATION DU COMPOSANT :

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="TagListComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <!--  Bloc affiché en cas d'absence de tag-->
        <empty-view-bloc-comp
            v-show="tagCount==0 && componentIsReady"
            v-bind:emptyItemName="'Tag'" v-bind:noItemTitle="$t('aucunTag')" v-bind:c2aTxt="$t('créezVotrePremierTagPourCommencer')" ></empty-view-bloc-comp>

        <!--  Bloc placeholder affiché pendant le chargement des tags-->
        <div class="appBloc" id="blocLoadingTags" v-if="!componentIsReady">
            <table class="table is-fullwidth">
                <tbody>
                <loading-timerecord-comp v-for="index in 10" :key="index"></loading-timerecord-comp>
                </tbody>
            </table>
        </div>

        <!-- liste des tags -------------------------------------------->


      <div v-else-if="tagCount > 0" >


              <div class="table-container"> <!-- rend le tableau scrollable si besoin (pour les mobiles)-->
                  <table class="appBloc table is-fullwidth tableTag" id="tagTable">

                    <thead>
                    <tr class="lineTag has-text-left">
                      <th colspan="" class="thead is-uppercase">#</th>
                      <th colspan="" class="thead is-uppercase">{{ $t('nom') }}</th>
                      <th colspan="" class="thead is-uppercase">{{ $t('description') }}</th>
                      <th colspan="" class="is-uppercase is-hidden-touch">
                        {{ $t('Créateur') }}
                      </th>

                      <th colspan="" class="is-uppercase is-hidden-touch "> {{ $t('statut') }}</th>
                      <th colspan="" class="is-uppercase  "></th>
                    </tr>
                    </thead>

                  <tbody >
                    <tr v-for="(tag,index) in tags" v-bind:key="tag.slug" class="has-text-left tagLine"  v-bind:id="'tag_'+tag.slug" v-bind:class="'tag_'+(index+1)">

                      <td class="index">
                        {{index + 1}}
                      </td>

                      <td class="tagName">

                        <!-- affichage du tag si non archivé-->
                        <span v-if="true" >
                          <tag-comp v-if="userCanEditTag(tag)" class="is-clickable" v-bind:title="$t('modifierLeTag')" v-on:click.native="modifyTag(tag)" v-bind:tag="tag"></tag-comp>
                          <tag-comp v-else v-bind:tag="tag" ></tag-comp>
                        </span>

                      </td>

                      <td class="description">
                        <span class="" v-if="tag.description!=null">{{tag.description}}</span><span v-else>-</span>
                      </td>

                      <td class="owner is-hidden-touch ">
                          <span class="fullname">
                            {{ tag.createdBy.firstname + ' ' + tag.createdBy.name }}
                          </span>
                      </td>

  <!--                    <td class="createdAt " v-bind:title="$t('DateCréation')">{{$moment(tag.createdAt).fromNow()}}</td>-->

                      <td class="status is-hidden-touch  ">
                          <span class="tagArchived has-text-grey-light"  v-if="tag.isArchived">
                              <font-awesome-icon  class="icon mr-1" :icon="['fas', 'folder']" />
                              {{$t('archivé')}}
                          </span>
                          <span v-else class=" tagActive ">
                            <font-awesome-icon  class="icon mr-1 has-text-success" :icon="['fas', 'check']" />
{{$t('actif')}}</span>
                      </td>

                      <td class="menuLink" v-bind:title="$t('afficherLeSousMenu')">
                          <font-awesome-icon
                                  v-if="userCanEditTag(tag)"
                                  v-bind:id="'menuOpener_'+tag.slug"
                                  v-on:click="showMenu(index)" class="icon menuOpener"
                                  :icon="['fas', 'ellipsis-v']"/>
                      </td>

                      <div class="menu" v-show="tag.showMenu" v-on:mouseleave="hideMenus()">
                          <ul>
                              <li v-on:click="modifyTag(tag)" class="editLink">
                                  <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>
                                  <a>{{$t('modifier')}}</a>
                              </li>

                              <li class="unArchiveLink" v-if="tag.isArchived" v-on:click="archiveTag(tag,'restore')">
                                  <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                  <a >{{$t('désarchiver')}}</a>
                              </li>
                              <li  class="archiveLink" v-else v-on:click="archiveTag(tag,'archive')">
                                  <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                  <a  >{{$t('archiver')}}</a>
                              </li>

<!--                              <li class="deleteLink" v-bind:id="'deleteLink_'+tag.slug"--> <!-- @todo réactiver dans https://gitlab.com/ousmane1/kronocloud/-/issues/764-->
<!--                              >-->
<!--                                  <font-awesome-icon class="icon" :icon="['fas', 'trash-alt']"/>-->
<!--                                  <a v-on:click="openModalDeleteTag(tag)">{{$t('supprimer')}}</a>-->
<!--                              </li>-->
                          </ul>
                      </div>
                  </tr>

                  </tbody>
                </table>
              </div>
         </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../../mixins/SentryMixin.js";
    import LoadingTimerecordComp from "../PlaceholderTimerecordComp";

    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import EmptyViewBlocComp from "@/components/EmptyViewBlocComp";
    import TimeMixin from "@/mixins/TimeMixin";
    import TagComp from "@/components/Tags/TagComp";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'TagListComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TimeMixin, TrackingMixin],
        components: {TagComp, EmptyViewBlocComp, LoadingTimerecordComp},

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale,
              // pour les composants où l'user est identifié ///////////////////////
              organizationSlug: this.$route.params.organization,
              workspaceSlug: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290

              userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
              componentIsReady: false, // indique quand le composant est prêt à être affiché (tags chargés)
              tagCount: 0, // le nombre total de tags dans la vue
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                tags: state => state.TagsView.tags,
                themeToDisplay: state => state.app.themeToDisplay

            }),

            //----------------------------------------------

        },
        watch: {

          tags :  function (){ // maj le nombre de tags quand les tags sont modifiés
              this.tagCount = this.tags.length
          }
        },


        methods: {

            /**
             * Met le store à jour avec editedTag
             * @param editedTag object le tag mis à jour à mettre dans le store
             * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
             *
             */
        updateTagInStore(editedTag){
            // on remplace le tag édité dans le store

            // Trouve l'index de l'objet à remplacer dans le store
            var index = _.findIndex(this.tags, {slug: editedTag.slug});

            editedTag.showMenu = false // on définit l'affichage du .menu à false

            // Remplace l'objet à l'index précédemment trouvé
            this.tags.splice(index, 1, editedTag);

        },

            /**
             * Ajoute un tag dans le store.
             * Utilisé pour maj le dom après la création d'un tag.
             * @param tag2Add object le tag à ajouter dans le store
             *
             */
            addTagInStore(tag2Add){
                let tagsInStore =  this.tags
                // on ajoute le tag au début du tableau (car loadTags() charge en desc)
                tag2Add.showMenu = false // on initialise l'affichage du .menu à false

                tagsInStore.unshift(tag2Add)
                this.$store.commit('UpdateTagsViewTags', tagsInStore)
            },

            /**
             * Supprime un tag dans le store.
             * Utilisé pour maj le dom après la suppression d'un projet.
             * @param project2Del object le projet à supprimer dans le store
             * @todo réactiver pour https://gitlab.com/ousmane1/kronocloud/-/issues/764
             *
             */
            // removeProjectInStore(project2Del){
            //     // Trouve l'index de l'objet à modifier dans le store
            //     var index = _.findIndex(this.projects, {slug: project2Del.slug});
            //     project2Del.showMenu = false // on réinit l'affichage du .menu à false (oui l'élément est supprimé mais un autre a pu prendre sa place) @todo améliorer car imparfait
            //
            //     // supprime l'objet à l'index précédemment trouvé
            //     this.projects.splice(index, 1);
            // },

            /**
             * Récupère les tags du workspace.
             * @param {String} filter - une chaîne pour filtrer par nom et description des tags
             */
            loadTags(filter) {
                let self = this;
                self.$http.get(
                    `organizations/${self.organizationSlug}/workspaces/${self.workspaceSlug}/tags`,
                    {
                        params: {
                            filter: filter,
                            sort: 'desc', // on récupère les plus récents en premier
                            archive: 'all', // on récupère les tags archivés + actifs
                        },
                        headers: {Authorization: self.$auth.header()},
                        timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps @todo à améliorer à terme ?

                    }
                )
                    .then(function (response) {
                       self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on injecte une propriété 'showMenu' dans chaque tags (qui sert à gérer l'affichage des .menu)
                        let tags = []
                        response.data.forEach(function (value) {
                            value.showMenu = false;
                          tags.push(value);
                        })

                        // stockage dans le store
                        self.$store.commit('UpdateTagsViewTags', response.data)
                        self.componentIsReady = true

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0064a'
                            let msg = 'error fetching tags'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id": errorCode,"detail": msg})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | '+msg, 'fatal': false})

                          self.$sentry.captureMessage(`Error ${errorCode} > "${msg} : ${error}`, 'error')
                        }
                    })
                    .then(() => {
                        // toujours exécuté
                    })
            },


            /**
             * Masque tous les éléments .menu
             **/
            hideMenus() {
                this.tags.forEach(function (value) {
                    value.showMenu = false;
                })
            },
            /**
             * Affiche l'élément .menu dont index est passé.
             * @param index int | Index du menu à afficher
             */
            showMenu(index) {
                this.hideMenus(); // on masque un éventuel .menu affiché au préalable
                this.tags[index].showMenu = true;
            }

            /**
             * Ouvre la modal tag management pour modifier un tag
             * @param tagToModify L'objet Tag à modifier
             */
            , modifyTag(tagToModify) {
                this.$root.$emit('show_modal_tag_management','edition', tagToModify)
            }

            /**
             * Archive/restaure un tag
             * @param tag Object tag à archiver
             * @param mode String L'action à effectuer (archive/restore)
             */
            ,archiveTag(tag,mode){

                const params = {}
                switch (mode) {
                    case  'archive': params.isArchived= true; break;
                    case  'restore': params.isArchived= false; break;
                }

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/workspaces/${self.workspaceSlug}/tags/${tag.slug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on maj le store avec le tag modifié
                        self.updateTagInStore(response.data)

                        // tracking
                        self.$mixpanel.track("Tag archived", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Tag archived' , {})

                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                          if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0065' ; let msg = "error archiving tag";
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": msg})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | ' +msg, 'fatal': false})
                            self.$sentry.captureMessage(`Error ${errorCode} > ${msg}: ${error}`, 'error')
                          }
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Déclenche l'ouverture de la ModalDeleteProjectComp
             * @param projet Object projet à supprimer
             * @todo réactiver pour https://gitlab.com/ousmane1/kronocloud/-/issues/764
             */
            // ,openModalDeleteProject(project){
            //     this.$root.$emit('show_modal_delete_project',project)
            // }


            /**
             * Retourne true si l'utilisateur actuel à le droit de modifier le tag
             * @param tag Object | le tag à tester
             * @return {boolean}
             */
            ,userCanEditTag(tag){
                // Pour modifier un tag il faut être le createur du tag
                if(tag.createdBy.slug == this.$auth.getUserSlug()){
                    return true
                }
                // ...OU être ROLE_ADMIN dans la même organization
                else if(this.$auth.hasRole('ROLE_ADMIN') && this.$auth.getOrganization() == this.organizationSlug){

                  return  true
                }

            },
        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // NOTE le commentaire suivant date de la copie du ProjectListComp @todo toujours utile ? 👉 (NOTE : Le chargement initial des tags sera effectué via le watch une fois que this.user aura été hydraté ( car le slug de l'user est requis dans la route) | Il faut tout de même charger ici pour fixer le bug #332 (https://gitlab.com/ousmane1/kronocloud/-/issues/332))
            this.loadTags()

            // listener de l'event new_tag_added, pour m.a.j les tag si un tag est ajouté
            this.$root.$on('new_tag_added', (tagAdded) => {
                this.addTagInStore(tagAdded)
            })

            // listener de l'event tag_edited, pour m.a.j les tags si un tag est modifié
            this.$root.$on('tag_edited', (tagEdited) => {
               this.updateTagInStore(tagEdited)
            })
            // listener de l'event project_deleted, pour m.a.j les projets si un projet est supprimé //@todo à gérer durant https://gitlab.com/ousmane1/kronocloud/-/issues/764
            // this.$root.$on('project_deleted', (projectEdited) => {
            //    this.removeProjectInStore(projectEdited)
            // })

        }
        ,beforeDestroy() {
          /**
           * Fix un potentiel bug d'insertion du tag en double après création (le bug s'était posé pour les porjets 👉 https://gitlab.com/ousmane1/kronocloud/-/issues/251)
           * N'a pas réellement pu être rerpoduit en dev donc à voir si le problème persiste
           * inspiré de : https://stackoverflow.com/a/61049328/666416 | https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them
           **/
          this.$root.$off('new_tag_added', () => {
          })
        },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    @import "../../assets/css/bulmaResponsiveDep.scss";

    #TagListComp{

    /////////////////////////////////////////
    // LIGHT THEME ///////////////////////////
    table.tableTag{



        .theadTag{
        }

        .icon{
          vertical-align: middle;

        }

        .tagName{

          min-width: $variableTxtMinWidth; // @todo voir pour faire sur les autre columns dont la taille varie beacoup
            padding-left: 2rem;
            @include mobile{
                padding-left: 1rem;
            }
            font-weight: bold;

        }
        .description{
          font-size: .85rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @include desktop{ max-width:$variableTxtMinWidth}
        }
        .status{
          .tagActive{
          }
        }
        .owner{
            .fullname{
                text-transform: capitalize;
            }
        }

        .menuLink{
            padding: 0;

            .icon{
                /*border:dashed 1px lightblue;*/
                cursor: pointer;
                margin-left: .2rem;
                font-size: 1.2rem;

                @include mobile{
                    margin: 0.9rem 2rem 0 1.5rem;
                }
                color:#ccc;

                &:hover{
                    color:$brandPrimary
                }
            }
        }
        .tagArchived{
            border-radius: 3px;
            font-size: 0.85rem;
            color:#666;
            min-width: 5.5rem;
          .icon{
            padding: 0;
            vertical-align: middle;
          }
        }
    }

    /////////////////////////////////////////
    // DARK THEME ///////////////////////////
      &.darkMode {
        .tagName{

        }

        .status{
          .tagActive{
            color: lighten($darkBg,15%) !important;
          }
          .tagArchived{
            color:$darkLightBlue !important;
          }
        }
      }
    }


</style>
